import React from 'react';
import { Avatar, Box, Card, CardContent, CardHeader, CircularProgress, Stack } from '@mui/material';
import { Person } from '@mui/icons-material';
import { translate as t } from 'hooks/useTranslations';
import DetailList from '_lex/_atoms/DetailList';
import { useEisFlaggedPersonnelDetails } from '../../../_data_sources/useEisFlaggedPersonnelDetails';

type Props = {
  personnelId: string;
};

const PersonnelDetailsCard: React.FC<Props> = ({ personnelId }) => {
  const personnelQuery = useEisFlaggedPersonnelDetails(personnelId, {}, (err) => {
    console.error('Error fetching EIS flagged personnel details:', err);
  });

  const personnel = personnelQuery.data;

  const personnelDetailsItems = [
    {
      label: t('performanceReporting.eis.details.flaggedPersonnelDetails.personnelDetails.name'),
      value: personnel?.name ?? '--',
    },
    {
      label: t('performanceReporting.eis.details.flaggedPersonnelDetails.personnelDetails.id'),
      value: personnel?.id ?? '--',
    },
    {
      label: t('performanceReporting.eis.details.flaggedPersonnelDetails.personnelDetails.groups'),
      value: personnel?.groups || '--',
    },
  ];

  if (personnelQuery.isLoading) {
    return (
      <Card className='lex-card'>
        <CardHeader title={t('performanceReporting.eis.details.flaggedPersonnelDetails.personnelDetails.title')} />
        <CardContent>
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
            <CircularProgress />
          </Box>
        </CardContent>
      </Card>
    );
  }

  if (personnelQuery.isError) {
    return (
      <Card className='lex-card'>
        <CardHeader title={t('performanceReporting.eis.details.flaggedPersonnelDetails.personnelDetails.title')} />
        <CardContent>
          <Box sx={{ p: 4, textAlign: 'center', color: 'error.main' }}>
            {t('performanceReporting.eis.details.flaggedPersonnelDetails.errorLoading')}
          </Box>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card className='lex-card'>
      <CardHeader title={t('performanceReporting.eis.details.flaggedPersonnelDetails.personnelDetails.title')} />
      <CardContent>
        <Stack
          spacing={3}
          alignItems='center'
        >
          <Avatar sx={{ width: 72, height: 72 }}>
            <Person fontSize='large' />
          </Avatar>
          <DetailList
            items={personnelDetailsItems}
            columns={1}
          />
        </Stack>
      </CardContent>
    </Card>
  );
};

export default PersonnelDetailsCard;
